export const LINK_HOMEPAGE = "/";
export const LINK_DASHBOARD = "/:clientProductId";
export const LINK_CREATE_SITE = "/:clientProductId/create-site";
export const LINK_DATABASES = "/:clientProductId/databases";
export const LINK_MANAGED_KEYS = "/:clientProductId/ssh-keys";
export const LINK_EMAIL = "/:clientProductId/email";
export const LINK_PMA = "/:clientProductId/pma";
export const LINK_AUDIT_LOG = "/:clientProductId/audit-log";

// Site-specific links
export const LINK_SITES = "/:clientProductId/sites";
export const LINK_SITE_SETTINGS = "/:clientProductId/sites/:siteId";
export const LINK_SITE_FILE_MANAGER =
  "/:clientProductId/sites/:siteId/file-manager";
export const LINK_SITE_REDIRECTS = "/:clientProductId/sites/:siteId/redirect";
export const LINK_SITE_DATABASES = "/:clientProductId/sites/:siteId/databases";
export const LINK_SITE_SSH_KEYS = "/:clientProductId/sites/:siteId/keys";
export const LINK_SITE_CRON_JOBS = "/:clientProductId/sites/:siteId/cron";
export const LINK_SITE_CLONE = "/:clientProductId/sites/:siteId/clone";
export const LINK_SITE_SECURITY = "/:clientProductId/sites/:siteId/security";
export const LINK_SITE_TAB = "/:clientProductId/sites/:siteId/:tabValue";

// External documentation links
export const LINK_SUPPORT_DOCUMENTATION = "https://citodocs.prostack.host/";
export const LINK_SUPPORT_DOCUMENTATION_SUPPORT =
  "https://citodocs.prostack.host/support/";
export const LINK_SUPPORT_DOCUMENTATION_CACHING =
  "https://citodocs.prostack.host/caching/";
export const LINK_SUPPORT_TICKET =
  "https://www.prostack.uk/portal/submitticket.php";
export const LINK_SUPPORT_DOCUMENTATION_NODE =
  "https://citodocs.prostack.host/node/";
export const LINK_SUPPORT_DOCUMENTATION_SSH =
  "https://citodocs.prostack.host/ssh/";
export const LINK_SUPPORT_DOCUMENTATION_REDIRECTS =
  "https://citodocs.prostack.host/redirects/";
export const LINK_SUPPORT_DOCUMENTATION_CRON =
  "https://citodocs.prostack.host/crons/";
export const LINK_SUPPORT_DOCUMENTATION_CHANGELOG =
  "https://citodocs.prostack.host/changelog/";

export const LINK_SUPPORT_DOCUMENTATION_CHANGELOG_MD =
  "https://citodocs.prostack.host/changelog.md";
